{
  "it": {
    "task": {
      "actions": {
        "create": "Attività",
        "create_and_send": "Crea e invia",
        "delete": "Elimina attività",
        "open_in_project": "Apri l'attività nel progetto",
        "remove_from_unit": "Rimuovi l'attività da questa unità",
        "save_as_draft": "Salva come bozza",
        "update": "Modifica attività"
      },
      "attributes": {
        "assignments_count": "Assegnazioni",
        "category": "Modo di completamento",
        "created_at": "Creato",
        "description": "Descrizione",
        "title": "Titolo",
        "units": "Unità"
      },
      "categories": {
        "confirmation": "Conferma",
        "upload": "Caricamento documento"
      },
      "categories_info": {
        "confirmation": "L'assegnatario spunta l'attività quando è fatta.",
        "upload": "L'assegnatario deve caricare un documento per completare l'attività."
      },
      "confirm": {
        "delete_body": "L'attività scompare, e con essa ogni assegnazione: {assignments} su {units}.",
        "delete_header": "Eliminare «{title}»?",
        "delete_silent": "Nessuno riceve una notifica, e le notifiche già inviate non vengono ritirate.",
        "remove_from_unit_body": "Ogni responsabile di «{title}» su {unit} la perde. L’attività stessa e le sue altre unità restano invariate.",
        "remove_from_unit_customers": "I clienti di {unit} non la vedono più nel loro portale.",
        "remove_from_unit_header": "Rimuovere questa attività da {unit}?"
      },
      "filters": {
        "phase_none": "Nessuna fase"
      },
      "labels": {
        "assignments_count": "{count} assegnazione | {count} assegnazioni",
        "created_by": "Creato da {name} · {date}",
        "created_on": "Creato il {date}",
        "no_tasks": "Ancora nessuna attività per questo progetto.",
        "required": "Questo campo è obbligatorio",
        "set_all_assignees": "Imposta per il responsabile | Imposta per tutti i {count} responsabili",
        "still_to_do": "{count} ancora da fare",
        "units_count": "{count} unità | {count} unità",
        "units_required": "Selezioni almeno un’unità"
      },
      "toasts": {
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "remove_from_unit": "Attività rimossa da questa unità",
        "update": "Attività aggiornata"
      }
    }
  }
}
